var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cpv-selector',{staticClass:"h-100",attrs:{"id":"cpv-selector","selectedCpv":this ? this.$attrs.selectedCpv : {}},on:{"selectCpv":_vm.selectCpv}})
}
var staticRenderFns = []

export { render, staticRenderFns }